import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserState } from './user-state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(
    private http: HttpClient,
    private userState: UserState,
    private router: Router,
    private actRoute: ActivatedRoute
  ) {}

  login(payload: {password: string; username: string;}) {
    return this.http.post<loginResponse>(`${environment.api_url}/Account/login`, payload);
  }

  forgotPwd(payload: {email: string, resetPasswordURL: string}) {
    return this.http.post<any>(`${environment.api_url}/Account/forgot-password`, payload);
  }

  checkNewUser(payload: any) {
    return this.http.post<any>(`${environment.api_url}/Account/check-new-user`, payload);
  }

  updatePassword(payload: {userId: number; newPassword:string; confirmNewPassword: string;}) {
    return this.http.patch<any>(`${environment.api_url}/Account/change-password`, payload);
  }

  changePassword(payload: any) {
    return this.http.patch<any>(`${environment.api_url}/Account/change-password`, payload);
  }

  authenticateUser(payload: loginResponse) {
    this.userState.initState(payload);

    this.actRoute.queryParams.pipe(take(1)).subscribe( params => {
      this.router.navigateByUrl(params['redirect'] ?? this.userState.defaultLoginRedirectUrl)
    });

  }

}


export type loginResponse = {
  data: {
    user: applicationUser;
  };
  expiration: string;
  token: string;
};

export type applicationUser = {
  id: number;
  organizationId: number;
  isUserAutorize: boolean;
  roles: string;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  phone: string;
  isActive: boolean;
  photoThumbnailPath: string;
  isFirstLogin: boolean;
  isForceLoggedOut: boolean;
  salutationName: string;

  isEmailConfirmed? : boolean;
  userTypeId? : number;
  hospitalId:number
};
